var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_1358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1625 54.0625C33.4249 55.3147 21.5875 55.3147 9.84997 54.0625C7.57066 53.8218 5.44271 52.8071 3.82089 51.1875C2.19906 49.568 1.18137 47.4415 0.937476 45.1625C-0.31477 33.425 -0.31477 21.5875 0.937476 9.85001C1.17817 7.57069 2.19288 5.44274 3.81243 3.82092C5.43197 2.1991 7.5585 1.1814 9.83747 0.937506C21.575 -0.31474 33.4124 -0.31474 45.15 0.937506C47.4293 1.17821 49.5572 2.19291 51.1791 3.81246C52.8009 5.432 53.8186 7.55853 54.0625 9.83751C55.3147 21.575 55.3147 33.4125 54.0625 45.15C53.8218 47.4293 52.8071 49.5573 51.1875 51.1791C49.568 52.8009 47.4415 53.8186 45.1625 54.0625Z",
    fill: "#E60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8844 19.2312C43.1969 17.1156 40.9219 15.8344 38.8282 15.5406C31.2973 14.7406 23.7028 14.7406 16.1719 15.5406C14.0782 15.8344 11.7969 17.1031 11.1157 19.2312C10.0438 24.6927 10.0438 30.3104 11.1157 35.7719C11.8032 37.8844 14.0782 39.1687 16.1719 39.4625C23.7028 40.2625 31.2973 40.2625 38.8282 39.4625C40.9219 39.1687 43.2032 37.9 43.8844 35.7719C44.9563 30.3104 44.9563 24.6927 43.8844 19.2312ZM23.3875 34.0875V20.9125L34.1125 27.5C30.4969 29.7219 26.9875 31.875 23.3875 34.0875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_1358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4f76f23c42c42a8ee6b246dde03145c2.svg";
export { ForwardRef as ReactComponent };